import { PropagandaModel } from "model/api/gestao/propaganda/propaganda-model";
import { CardNaoEncontrado } from "views/components/cards";
import { CardPropaganda } from "views/components/cards/card-propaganda/card-propaganda";
import { InformacaoIcon } from "views/components/icons";

export interface PropagandaListDataProps {
  list: Array<PropagandaModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (id: string) => any;
  onCardChecked: (id: string) => any;
}

export const PropagandaListData = (props: PropagandaListDataProps) => {

  const onCardSelected = (id: string) => {
    props.onCardSelected(id);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhuma Propaganda Encontrada."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props?.list.length > 0 &&
        props.list.map((propaganda, index) => {
          return (
            <CardPropaganda
              selected={
                props.selectedList.filter((item) => item === propaganda.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={propaganda}
              key={index}
            />
          );
        })}
    </>
  );
};
